import React from 'react';
import redrightarrow from "../../assets/images/contact/arrow.png";
import styles from "../../pages/upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import dynamic from 'next/dynamic';
const Image = dynamic(() => import("next/image"));
const Link = dynamic(() => import("next/link"));


const ObtionalButton = () => { 
    return (
        <>

     {/* <div className=" ">
                 <a href="https://www.shankariasacademy.com/forestry-admission/" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.obtionalbutton}`}> Forestry & Geology Optional <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" /></button></a>
      </div> */}

        </>
    
       
    );
}

export default ObtionalButton